<div id="app-datepicker">
  @if (showPrevNext) {
    <div class="prev-btn">
      <button
        type="button"
        pButton
        icon="fa fa-arrow-circle-left"
        (click)="previousDateEvent()"
        class="nav-button cal-button"
        id="app-datepicker-previous-button"
      ></button>
    </div>
  }
  <div class="calendar">
    <p-datepicker
      [showIcon]="showIcon()"
      (ngModelChange)="onModelChange($event)"
      (onFocus)="onFocus()"
      (onBlur)="onBlur($event)"
      [ngModel]="calendarDate"
      [selectionMode]="selectionMode()"
      [styleClass]="styleClass()"
      [inputStyleClass]="inputStyleClass()"
      [name]="name()!"
      [placeholder]="placeholder()"
      [defaultDate]="defaultDate()!"
      [disabled]="isDisabled"
      [dateFormat]="dateFormat()"
      [inline]="inline()"
      [showOtherMonths]="showOtherMonths()"
      [selectOtherMonths]="selectOtherMonths()"
      [showIcon]="showIcon()"
      [showOnFocus]="showOnFocus()"
      [icon]="icon()"
      [appendTo]="appendTo()"
      [shortYearCutoff]="shortYearCutoff()"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [disabledDates]="disabledDates()!"
      [disabledDays]="disabledDays()!"
      [showTime]="showTime()"
      [hourFormat]="hourFormat()"
      [timeOnly]="timeOnly()"
      [dataType]="dataType()"
      [required]="required()"
      [tabindex]="tabindex()"
      [showSeconds]="showSeconds()"
      [stepHour]="stepHour()"
      [stepMinute]="stepMinute()"
      [stepSecond]="stepSecond()"
      [todayButtonStyleClass]="todayButtonStyleClass()"
      [clearButtonStyleClass]="clearButtonStyleClass()"
      [baseZIndex]="baseZIndex()"
      [autoZIndex]="autoZIndex()"
      [panelStyleClass]="panelStyleClass()"
      [keepInvalid]="keepInvalid()"
      [hideOnDateTimeSelect]="hideOnDateTimeSelect()"
    />
  </div>
  @if (showPrevNext) {
    <div class="next-btn">
      <button
        type="button"
        pButton
        icon="fa fa-arrow-circle-right"
        (click)="nextDateEvent()"
        class="nav-button cal-button"
        id="app-datepicker-next-button"
      ></button>
    </div>
  }
</div>
